export enum EInvoiceStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    // PAID = 'PAID',
    // PARTIAL_PAID = 'PARTIAL_PAID',
}
